import { URL_BASE } from "../constants";
import { getRequest } from "../requests";

export async function getAllStates() {
    const response = await getRequest(`${URL_BASE}/states`);
    return response.data;
}